import { render, staticRenderFns } from "./ProductInformations.vue?vue&type=template&id=46b4a0ba&scoped=true"
import script from "./ProductInformations.vue?vue&type=script&lang=js"
export * from "./ProductInformations.vue?vue&type=script&lang=js"
import style0 from "./ProductInformations.vue?vue&type=style&index=0&id=46b4a0ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4a0ba",
  null
  
)

export default component.exports